import { dsvFormat } from 'd3-dsv';
import { formatDefaultLocale } from 'd3-format';
import { scaleLinear } from 'd3-scale';

import isoLookupFile from './isolookup';
import { categories, weightCol, amountCol } from '../config';

export const opacityScale = scaleLinear([0.02, 0.8], [0.2, 0.8]).clamp(true);

const germanNumberFormat = formatDefaultLocale({
  decimal: ',',
  thousands: '.',
  grouping: [3],
  currency: ['€', ''],
});

export function formatNumber(num, decimals = 0, unit = false) {
  if (typeof num === 'undefined') {
    return '';
  }

  const formattedNumber = germanNumberFormat.format(`,.${decimals}f`)(num);

  return unit ? `${formattedNumber} ${unit}` : formattedNumber;
}

export const isoLookup = isoLookupFile;

export function isNumeric(number) {
  if (typeof number === 'undefined') {
    return false;
  }

  return !isNaN(number) && isFinite(number);
}

export const parseNum = (num) => {
  if (typeof num === 'undefined') {
    return null;
  }

  return +num.replace(',', '.');
};

export const formatWeight = (weight) => {
  // if (weight < 1000) {
  //   return formatNumber(weight, 2, 'kg');
  // }

  return formatNumber(weight / 1000, 2, 't');
};

export const sum = (data, key) =>
  data.reduce((res, item) => {
    if (isNumeric(item[key])) {
      res += item[key];
    }

    return res;
  }, 0);

export function sortByKey(key, isAsc = true) {
  return (a, b) => {
    if (a[key] > b[key]) {
      return isAsc ? 1 : -1;
    } else if (a[key] < b[key]) {
      return isAsc ? -1 : 1;
    } else {
      return 0;
    }
  };
}

export const getCategoryByKey = (key) =>
  categories.find((cat) => cat.key === key);

export const parseProductData = (data) => {
  return data.map((d) => ({
    ...d,
    [weightCol]: parseNum(d[weightCol]),
    [amountCol]: parseNum(d[amountCol]),
  }));
};

export const loadCsv = async (filePath, delimiter = ',') => {
  const csv = dsvFormat(delimiter);

  const res = await fetch(filePath);
  const text = await res.text();

  return csv.parse(text);
};

export const isSmallScreen = window.innerWidth < 800;

export const supportsTouch =
  'ontouchstart' in window || navigator.msMaxTouchPoints;

export const getMapTransform = () => {
  const containerWidth = Math.min(1164, window.innerWidth);

  return `translate(${-(containerWidth * 0.025)} 0)`;
};
